import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Button } from 'react-bootstrap'
import { RightIcon, CrossIcon } from '../assets/images';
import { getDashboard, clearBaselineReducer } from '../hooks/dashboard'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    dashboard: state.dashboard,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  getDashboard: () => dispatch(getDashboard()),
  clearBaselineReducer: () => dispatch(clearBaselineReducer())
});

const scoreColour = (data) => {
  var classSpell = " d-score-yellow"
  if (data.today_cas_score == null) {
    classSpell = ""
    return classSpell
  }
  if (data.today_cas_score > data.current_cas_baseline) {
    classSpell = " d-score-green"
  }

  if (data.today_cas_score < data.current_cas_baseline) {
    classSpell = " d-score-red"
  }
  return classSpell
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
}

class Dashboard extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      shouldNavigate: false,
      path: null
    };
    this.props.clearBaselineReducer()
  }

  componentDidMount() {
    if (!this.props.auth.baseline) {
      this.setState({
        shouldNavigate: true,
        path: "/alertness"
      })
    } else {
      this.props.getDashboard()
    }
  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true} />
      <div className="page-sections">
        <div className='dashboard-wrap'>
          {this.props.dashboard.data !== null ?
            <Container>
              <div className='dashboard-contents'>
                <h2 className='main-title-style'>DASHBOARD</h2>
                <div className='dashboard-scores'>
                  <div className='dashboard-single-score'>
                    <span className='tdy-cas-score'>TODAY’S CAS SCORE:</span>
                    <div className={'dash-score' + scoreColour(this.props.dashboard.data)}>
                      {this.props.dashboard.data.today_cas_score !== null ? parseInt(this.props.dashboard.data.today_cas_score) : null}
                    </div>
                  </div>
                  <div className='dashboard-single-score'>
                    <span>Current CAS baseline score:</span>
                    <div className='dash-score d-score-blue'>
                      {parseInt(this.props.dashboard.data.current_cas_baseline)}
                    </div>
                  </div>
                  <div className='dashboard-single-score'>
                    <span>Highest CAS score {this.props.dashboard.data.highest_cas_date}:</span>
                    <div className='dash-score'>{parseInt(this.props.dashboard.data.highest_cas_score)}</div>
                  </div>
                  <div className='dashboard-single-score'>
                    <span>Lowest CAS score {this.props.dashboard.data.lowest_cas_date}:</span>
                    <div className='dash-score'>{parseInt(this.props.dashboard.data.lowest_cas_score)}</div>
                  </div>
                </div>
                <div className='past-new-score-btns'>
                  <a href="/daily-alertness" rel="nofollow"><button className='past-btn'>PAST SCORES</button></a>
                  <a href="/daily-questionnaire" rel="nofollow"><button className='new-btn'>NEW DAILY TEST</button></a>
                </div>
                <div className='participated-days-tracker'>
                  <span>Days participated</span>
                  <div className='dasboard-participated'>
                    {this.props.dashboard.data.numerr_of_participation} / {this.props.dashboard.data.number_of_days} active days
                  </div>
                </div>
                <div className='dashboard-tracking'>
                  <div className='dashboard-single-track'>
                    <div className="dashboard-question">
                      <span>Essential questions</span>
                      <img src={this.props.dashboard.data.essential_test ? RightIcon : CrossIcon} alt="Right Icon" />
                    </div>
                    {!this.props.dashboard.data.essential_test ? <a href="/onboarding-process" rel="nofollow"><button>START</button></a> : null}
                  </div>
                  <div className='dashboard-single-track'>
                    <div className="dashboard-question">
                      <span>Voluntary sleep health assessment</span>
                      <img src={this.props.dashboard.data.voluntary_test ? RightIcon : CrossIcon} alt="Cross Icon" />
                    </div>
                    {!this.props.dashboard.data.voluntary_test ? <a href="/self-assessment" rel="nofollow"><button>START</button></a> : null}
                  </div>
                </div>
                {this.props.dashboard.data.voluntary_test ? <a href={this.props.dashboard.data.personal_report} target='_blank' rel="nofollow">  <Button className='download-report'>DOWNLOAD PERSONALISED REPORT</Button> </a>
                  : null}
              </div>
            </Container> : null}
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />

    </Fragment>
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
